import * as amplitude from '@amplitude/analytics-browser';
import { plugin as engagementPlugin } from '@amplitude/engagement-browser';

const AmplitudeService = {
  init(apiKey) {
    amplitude.init(apiKey, {
      defaultTracking: true
    });

    amplitude.add(engagementPlugin());
  },

  identify(userId: string, properties: any) {
    amplitude.setUserId(userId);

    const identify = new amplitude.Identify()
      .set('email', properties.email)
      .set('name', properties.name)
      .set('organization', properties.organization);
    amplitude.identify(identify);

    this.bootEngagement(userId, properties);
  },

  track(eventName: string, properties: any) {
    amplitude.track(eventName, {
      buttonName: properties.button_name,
      page: properties.page,
      ...properties
    });
  },

  async bootEngagement(user_id: string, user_properties: any) {
    if (typeof window !== 'undefined' && (window as any).engagement) {
      try {
        await (window as any).engagement.boot({
          user: { user_id, user_properties },
          integrations: [
            {
              track: (event: any) => this.track(event.event_type, event.event_properties)
            }
          ]
        });
      } catch (error) {
        console.warn('Failed to boot Guides & Surveys:', error);
      }
    }
  }
};

export default AmplitudeService;
